import { createFileRoute } from '@tanstack/react-router';

import CheckListSettings from '@/modules/hang-tags/pages/CheckListSettings';

export const Route = createFileRoute(
  '/_authenticated/_system/_tenant/settings/hang-tag/check-list/',
)({
  head: () => ({
    meta: [{ title: 'Configurações de Check List' }],
  }),
  component: CheckListSettings,
});
